import { type PropsWithChildren, type ReactNode } from "react";

import { Drawer } from "..";
import { cn } from "../../../utils";

export interface DrawerBottomProps extends PropsWithChildren {
  trigger: ReactNode;
  className?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const DrawerBottom = ({ trigger, children, className, open, onOpenChange }: DrawerBottomProps) => {
  return (
    <Drawer.Root direction="bottom" open={open} onOpenChange={onOpenChange}>
      <Drawer.Trigger asChild>{trigger}</Drawer.Trigger>
      <Drawer.Portal>
        <Drawer.Overlay className="z-50! bg-black! opacity-60!" />
        <Drawer.Content className="h-auto w-full rounded-xl border-none bg-transparent">
          <div className={cn("m-4 flex min-h-20 flex-col rounded-xl bg-white p-4", className)}>
            <div className="mx-auto mb-3 h-1.5 w-16 rounded-full bg-neutral-90" />
            {children}
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};

export default DrawerBottom;
